module.exports = __webpack_public_path__ + "img/short.3c8d206b.svg";